import type { UserPermission, User } from "./auth-context";

export type PermissionAction = "create" | "read" | "update" | "delete" | "export" | "share";

const actionMap: Record<PermissionAction, keyof UserPermission> = {
	create: "canCreate",
	read: "canRead",
	update: "canUpdate",
	delete: "canDelete",
	export: "canExport",
	share: "canShare",
};

export function hasPermission(
	user: User | null,
	module: string,
	action: PermissionAction,
): boolean {
	if (!user) return false;
	const perm = user.permissions?.find((p) => p.module === module);
	if (!perm) return false;
	return Boolean(perm[actionMap[action]]);
}
